module.exports = __webpack_public_path__ + "img/fotofundadoras2.0680097b.jpg";